/*global BMap */
import {
    observable,
    action,
    computed,
    reaction,
} from 'mobx';
import dayjs from "dayjs";

import { myConst } from "@/config/";
import { DATA_TYPE_CONFIG, DATA_TYPE_STREET } from "@/utils/dataType";


// import parkingSchema from "./schema/parking";


export default class DataStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
        Object.keys(DATA_TYPE_CONFIG).forEach(k => {
            this[`${k}_list`] = [];
        });

        reaction(() => this.dataType, dataType => {
            console.green(`DataType Change ${dataType}`);
            localStorage._dataType = dataType;
            this.rootStore.mapStore.changeAjaxState(false);
            // bug reaction 反应不过来
            // setTimeout(() => {
            // }, 100);
            this.checkData(dataType);
        }, { name: 'dataType change' });
    }



    @observable
    dataType = ''; // 初始值为空 等待进入 map 后触发相关操作

    // streetList = [];
    // parkingList = []
    // oilList = [];
    // newEnergyList = [];
    // wcList = [];

    @observable
    loading = {
        getList: false,
    };

    @observable
    cacheTips = {
        state: false,
        text: '',
    }


    @computed get dataList() {
        return this[`${this.dataType}_list`] || [];
        // switch (this.dataType) {
        //     case DATA_TYPE_STREET:
        //         return this.streetList;
        //     case DATA_TYPE_PARKING:
        //         return this.parkingList;
        //     case DATA_TYPE_OIL:
        //         return this.oilList;
        //     case DATA_TYPE_NEWENERGY:
        //         return this.newEnergyList;
        //     case DATA_TYPE_WC:
        //         return this.wcList;
        //     default:
        //         throw new Error('错误的类型');
        // }
    }


    @action.bound toggleCacheTips(options) {
        this.cacheTips.state = options.state;
        if (options.text) {
            this.cacheTips.text = options.text;
        } else {
            this.cacheTips.text = '';
        }
    }

    @action.bound changeType(type = DATA_TYPE_STREET) {
        this.dataType = type;
    }

    @action.bound setList({ type, data }) {
        const arr = data.map((v, i) => {
            v.type = type;
            v.imgBg = `./static/img/marker/${i % 100 + 1}.png `;
            v.bLoc = new BMap.Point(v.lng, v.lat);
            return v;
        });
        // 不可 freeze 每次点击图标会去Ajax后会把心数据重写v
        this[`${type}_list`] = arr;
        // switch (type) {
        //     case DATA_TYPE_STREET:
        //         this.streetList = arr;
        //         break;
        //     case DATA_TYPE_PARKING:
        //         this.parkingList = arr;
        //         break;
        //     case DATA_TYPE_OIL:
        //         this.oilList = arr;
        //         break;
        //     case DATA_TYPE_NEWENERGY:
        //         this.newEnergyList = arr;
        //         break;
        //     case DATA_TYPE_WC:
        //         this.wcList = arr;
        //         break;
        //     default:
        //         console.error('错误的类型');
        // }
        this.rootStore.mapStore.changeAjaxState(true);
    }

    @action.bound checkData(type) {
        try {
            if (!localStorage[localCacheName(type)]) throw new Error("无缓存");
            const cache = JSON.parse(localStorage[localCacheName(type)]);
            const time = cache.time;
            if (time + myConst.cacheTime < Date.now()) throw new Error("缓存过期");
            console.blue(`Use Cache | ${new Date(time).toLocaleString()}`);
            this.setList({ type, data: cache.body });
        } catch (error) {
            console.blue(`Not Use Cache | ${error.message}`);
            this.getListData(type);
        }
    }



    @action.bound getListData(type) {
        const _this = this;
        if (_this.loading.getList) return;
        _this.loading.getList = true;
        _this.toggleCacheTips({ state: false, text: `` });
        getTypeAjax(type)().then(resp => {
            const data = resp.data;
            // 服务器需要先排序，减少客户端运算 并且服务器需要筛选掉 没有 经纬度的 客户端不再处理
            if (data.code != 200) throw new Error(data.msg || "服务器内部错误");
            // 先缓存 不然 setList 被加上 proxy 就污染了
            try {
                localStorage[localCacheName(type)] = JSON.stringify({
                    time: Date.now(),
                    body: data.result,
                });
            } catch (e) {
                console.red('缓存错误', e.message);
                // 万一超过 5m 无法存储等极端情况
                localStorage[localCacheName(type)] = "";
            }
            _this.setList({ type, data: data.result });
        }).catch(err => {
            console.red("Ajax Get All Err", err.message);
            if (localStorage[localCacheName(type)]) {
                try {
                    const cache = JSON.parse(localStorage[localCacheName(type)]);
                    console.blue(`Ajax GetError Use Overdue Cache | ${new Date(cache.time).toLocaleString()}`);
                    _this.setList({ type, data: cache.body });
                    _this.toggleCacheTips({
                        state: true,
                        text: `无法连接服务器</br> 使用${dayjs(cache.time).format("YYYY-MM-DD hh:mm:ss")} 缓存`,
                    });
                    // 有缓存算正常进入 不写入错误
                    return;
                } catch (e) {
                    console.red(`Ajax Get ALl 写入本地缓存失败 ${e.message}`);
                }
            }
            if (document.querySelector("#loadingText")) {
                document.querySelector("#loadingText").classList.remove('hidden');
            }
        }).finally(() => {
            _this.loading.getList = false;
        });

    }
}

// class Parking {
//     constructor(data) {
//         extendObservable(this, data);
//     }
// }


// function createParking(data) {
//     return Object.assign({}, parkingSchema, data);
// }


function getTypeAjax(type) {
    return DATA_TYPE_CONFIG[type].getList;
}


function localCacheName(type) {
    return `_local_list_cache_${type}`;
}